import {
  Alert,
  Box,
  Card,
  FormControlLabel,
  Stack,
  Switch,
  Typography,
} from "@mui/material";
import { useMutation } from "@tanstack/react-query";
import { API_URL } from "./Constants";
import { Bell } from "./Icons";

// Its own card rather than a line inside auto-signup: the reminder is useful
// even to someone who registers by hand, so it isn't a sub-setting of
// auto-signup.
export const ReminderCard = ({
  dailyReminder,
  refetch,
}: {
  dailyReminder: boolean;
  refetch: () => void;
}) => {
  const save = useMutation({
    mutationFn: async (enabled: boolean) => {
      const res = await fetch(API_URL + "/daily-reminder", {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ enabled }),
      });
      if (res.status !== 200) {
        throw new Error(await res.text());
      }
      refetch();
    },
  });

  return (
    <Card>
      <Box padding="2em">
        <Stack direction="row" alignItems="center" spacing={1.2}>
          <Box sx={{ color: "secondary.main", display: "flex" }}>
            <Bell width={22} height={22} />
          </Box>
          <Typography variant="h5">Daily reminder</Typography>
        </Stack>

        {save.isError && (
          <Alert severity="error" sx={{ mt: 2 }}>
            {save.error.message || "Couldn't save that."}
          </Alert>
        )}

        <FormControlLabel
          sx={{ mt: 2 }}
          control={
            <Switch
              defaultChecked={dailyReminder}
              disabled={save.isPending}
              onChange={(e) => save.mutate(e.target.checked)}
            />
          }
          label={
            <Typography variant="body2">
              DM me today's games each morning
            </Typography>
          }
        />
      </Box>
    </Card>
  );
};
